﻿window.renderGoogleInvisibleRecaptcha = function () {
  function onVerify($element) {
    return function ($element) {
      var $element = $element;
      return function (response) {
        if (!response || response.length == 0) {
          $element.addClass('ValidationFail');
        } else {
          var closestTarget = $element.is(".au-recaptcha")
            ? ".FormStep"
            : "form";
          $element.parents(closestTarget).find("input.RecaptchaTokenResponse").val(response);
          $element.removeClass('ValidationFail');
          $element.addClass('RecaptchaValidationPassed');

          if ($element.is(".au-recaptcha")) {
            var $form = $element.closest("form");
            //MAke sure the button being clicked was already clicked by the user and clicked last or we have a step button
            if ($form.find('.FormSubmitButton.clicked-last').length == 0 && $form.find("button[data-f-navigation-next]").length == 0) return;
          
            if ($form.find('.FormSubmitButton.clicked-last').length > 0) {
              $form.find('.FormSubmitButton.clicked-last').removeAttr('disabled').click();
            }
            else if ($form.find("button[data-f-navigation-next]").length > 0) {
              // go to next step if we have multiple steps
              $form.find("button[data-f-navigation-next]").click();
            }
          } else {
            //MAke sure the button being clicked was already clicked by the user and clicked last.
            if ($element.closest("form").find('.FormSubmitButton.clicked-last').length == 0) return;

            //click it
            $element.closest("form").find('.FormSubmitButton.clicked-last').removeAttr('disabled').click();
          }

          //100px = offset of the sticky nav 
          $("html, body").animate({ scrollTop: $element.parents(".subscribe-block").offset().top - 100}, 0);
        }
      }
    }($element);
  };
  $(".Form__Element.FormInvisibleRecaptcha").each(function (index, element) {
    var $element = $(element),
      $widgetContainer = $(".g-recaptcha", $element),
      siteKey = $element.data("veforms-sitekey");

    if ($widgetContainer.length == 1 && siteKey) {
      var widgetId = grecaptcha.render($widgetContainer[0], {
        sitekey: siteKey,
        size: 'invisible',
        badge: 'bottomright',
        callback: onVerify($element)
      });
      element.dataset.epiformsRecaptchaWidgetid = widgetId;
    }
  });
  $('.grecaptcha-badge').css('display', 'none');
}


/* recaptchaChacker
 * Code to listen for whether the recaptcha element is done with it's validation and then to manually trigger the resubmission of the form. Either on the main-subscription-registration-form or the au-registration form.
 */

recaptchaCheckerWrapper = function () {

    //In the case of multiple buttons, we need to know which one was clicked last
    $(".FormSubmitButton").click(e => $(".FormSubmitButton").removeClass("clicked-last") && $(e.currentTarget).addClass("clicked-last"));

    window.recaptchaChecker = {

    triggered: false,
    initialised: false,
    classToCheck: "RecaptchaValidationPassed",
    elem: $(".main-subscription-registration-form .FormInvisibleRecaptcha, .au-registration .FormInvisibleRecaptcha")[0],
    observer: new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName == "class") {
                if (mutation.target.classList.contains(recaptchaChecker.classToCheck) && !recaptchaChecker.triggered) {
                    recaptchaChecker.classChangedTrigger(); 
                    recaptchaChecker.triggered = true;
                }
            }
        });
    }),
    classChangedTrigger: function () {
        $('.au-registration .FormSubmitButton, .main-subscription-registration-form .FormSubmitButton')[0].click();
        console.log("recaptchaChecker: Recaptcha passed, manually triggering form again.");
    },
    init: function () {
        if (recaptchaChecker.elem != undefined && !(recaptchaChecker.initialised)) {
            recaptchaChecker.observer.observe(recaptchaChecker.elem, {
                attributes: true
            })

            recaptchaChecker.initialised = true;
        }

    }

}
    recaptchaChecker.init();
}

window.addEventListener("DOMContentLoaded", recaptchaCheckerWrapper);